import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { RESPONSE } from '../constants';
import { AuthService } from '../services';
import { SnackBarService } from '../services/snack-bar.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  debounceTimer: any;

  constructor(
    private _snackbarService: SnackBarService,
    private _authService: AuthService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.startsWith('http') && request.url.includes('/api/')) {
      return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
          switch (error.status) {
            case 400:
              this._snackbarService.openSnackBar(
                error.error?.message ||
                  error.error?.data?.[0]?.errorMessage ||
                  error.error?.errors[
                    Object.keys(error.error?.errors)[0]
                  ]?.[0] ||
                  RESPONSE[400],
                'Warn'
              );
              break;
            case 401:                           
              clearTimeout(this.debounceTimer);
              this.debounceTimer = setTimeout(() => {
                this._snackbarService.openSnackBar(
                  error.error?.message || RESPONSE[401],
                  'Warn'
                );                
                if (!this._authService.isAutoSigningIn) {
                   this._authService.logout();
                }                
              }, 1000);
              // window.location.reload();
              // location.assign(location.origin);
              break;
            case 403:
              this._snackbarService.openSnackBar(RESPONSE[403], 'Warn');
              break;
            case 404:
              this._snackbarService.openSnackBar(
                error.error?.message || RESPONSE[404],
                'Error'
              );
              break;
            case 405:
              this._snackbarService.openSnackBar(RESPONSE[405], 'Error');
              break;
            case 409:
              this._snackbarService.openSnackBar(
                error.error?.message || RESPONSE[409],
                'Error'
              );
              break;
            case 500:
              this._snackbarService.openSnackBar(RESPONSE[500], 'Error');
              break;
          }
          return throwError(error);
        })
      );
    } else {
      return next.handle(request);
    }
  }
}
